import React from 'react'
import { t } from 'ttag'

import { Link } from 'components/shared/Link/Link'
import { ActionsCell } from 'components/shared/Table/common/Cells/ActionsCell/ActionsCell'
import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'

import { formatFileSize } from 'utils/stringFormat'
import { useDocumentsTable } from './hooks'

import { DownloadIcon } from 'components/shared/Icon/model'

import styles from './DocumentsTable.module.scss'

const mapSortingPropToQueryParam = {
  changed: 'changed',
  size: 'size',
  title: 'title',
}

export const DocumentsTable = ({ search }) => {
  const { state, handlers } = useDocumentsTable({
    mapSortingPropToQueryParam,
    search,
  })

  const {
    pagination: { currentPage, pageCount, perPage },
    table: { headers, model, isFetching },
  } = state
  const {
    pagination: { handlePage, handlePageSize },
  } = handlers

  return (
    <>
      <Table className={styles.table}>
        <Table.Head>
          <Table.Row>
            {headers.map(
              ({ columnDef, getToggleSortingHandler, getIsSorted }) => {
                const { accessorKey, header } = columnDef

                return (
                  <HeaderCell
                    key={header}
                    sortType={getIsSorted()}
                    text={header}
                    onClick={getToggleSortingHandler()}
                    hasSorting={accessorKey}
                  />
                )
              },
            )}
          </Table.Row>
        </Table.Head>
        <Table.Body
          placeholder={{ title: t`No documents available` }}
          isLoaded={!isFetching}
        >
          {model.rows.map(({ id, original }) => {
            const { changed, description, file, size, title } = original

            return (
              <Table.Row key={id}>
                <TextCell justify="flex-start" text={title} />
                <TextCell justify="flex-start" text={description} />
                <TextCell text={formatFileSize(size)} />
                <DateCell date={changed} hasNowLabel />
                <ActionsCell>
                  <Link
                    className={styles.link}
                    icon={DownloadIcon}
                    size="medium"
                    target="_blank"
                    to={file}
                    variant="text"
                    isExternal
                  />
                </ActionsCell>
              </Table.Row>
            )
          })}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
